var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRiskAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32812 3.72444V2.01931C5.32812 1.54845 5.72687 1.16675 6.21875 1.16675H9.33594C9.82782 1.16675 10.2266 1.54845 10.2266 2.01931V3.72444M2.65625 12.2501H13.3438C14.3275 12.2501 15.125 11.4867 15.125 10.545V5.42957C15.125 4.48785 14.3275 3.72444 13.3438 3.72444H2.65625C1.67249 3.72444 0.875 4.48785 0.875 5.42957V10.545C0.875 11.4867 1.67249 12.2501 2.65625 12.2501Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRiskAsset);
export default __webpack_public_path__ + "static/media/IconRiskAsset.2a471e7c227f6a63ca29c70038afb2ce.svg";
export { ForwardRef as ReactComponent };